module.exports = __webpack_public_path__ + "img/Sibiu_g_kl.1a106499.jpg";